







































































































































































































































































































































































































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins } from 'vue-property-decorator';
import GuestInfo from '@/components/GuestInfo.vue';
import PeopleSearchInput from '@/components/PeopleSearchInput.vue';
import { i18n } from '@/i18n';
import { IOrder, IPlace, IProductFlight, IProductProperty, PROPERTY_TYPES } from '@resclick/data-access';
import moment from 'moment';

@Component({
  components: {
    GuestInfo,
    PeopleSearchInput,
  },
})
export default class ChangeCompanyModal extends Mixins(ModalMixin) {
  order!: IOrder;

  // SEARCH
  queryForm = {
    fields: {
      product: 'HOTEL',
      search: '',
      checkInDate: '',
      checkOutDate: '',
      adults: 2,
      children: [] as number[],
      market: 0,
    },
  };

  get productTypeOptions() {
    return [
      { label: i18n.tc('GENERAL.HOTEL'), value: 'HOTEL' },
      { label: i18n.tc('GENERAL.FLIGHT'), value: 'FLIGHT' },
      { label: i18n.tc('GENERAL.TOUR'), value: 'TOUR' },
      { label: i18n.tc('GENERAL.TRANSFER'), value: 'TRANSFER' },
    ];
  }

  propertySearchOptions: any[] = [];

  filterFn(val: string, update: any, abort: any) {
    this.queryForm.fields.search = val;

    if (val.length < 3) {
      abort();
      return;
    }
    compass
      .do('autoCompletions', 'findPropertiesOrPlaces', {
        query: { key: val },
      })
      .then((res) => res.data)
      .then((data) => {
        update(
          () => {
            if (val === '') {
              this.propertySearchOptions = [];
            } else {
              this.propertySearchOptions = data.map((item) => {
                return {
                  label: item.name,
                  value: item.name,
                  type: item.type,
                };
              });
            }
          },
          (ref: any) => {
            if (val !== '' && ref.options.length > 0) {
              ref.setOptionIndex(-1); // reset optionIndex in case there is something selected
              ref.moveOptionSelection(1, true); // focus the first selectable option and do not update the input-value
            }
          },
        );
      });
  }

  abortFilterFn() {
    return;
  }

  get numberOfGuests() {
    return {
      adults: this.queryForm.fields.adults,
      children: this.queryForm.fields.children,
    };
  }

  set numberOfGuests(value: { adults: number; children: number[] }) {
    this.queryForm.fields.adults = value.adults;
    this.queryForm.fields.children = value.children;
  }

  get dateRange() {
    return {
      start: moment(this.queryForm.fields.checkInDate).format('YYYY-MM-DD'),
      end: moment(this.queryForm.fields.checkOutDate).format('YYYY-MM-DD'),
    };
  }

  set dateRange(value: any) {
    this.queryForm.fields.checkInDate = new Date(moment(value.start).format('YYYY-MM-DD')) as any;
    this.queryForm.fields.checkOutDate = new Date(moment(value.end).format('YYYY-MM-DD')) as any;
  }

  lastQuery: any = {};
  searchResult: any[] = [];
  currentProductIndex = 0;

  get focusProduct() {
    let property: any = {};
    if (this.searchResult[this.currentProductIndex]) {
      property = JSON.parse(JSON.stringify(this.searchResult[this.currentProductIndex]));
    }

    if (property) {
      let { rooms = [] } = property;
      const flat: any = [];
      rooms.forEach((room: any) => {
        const { ratePlans = [], ...rest } = room;
        ratePlans?.forEach((ratePlan: any) => {
          flat.push({
            ...rest,
            ratePlan,
          });
        });
      });

      property.rooms = flat;

      property.rooms.sort((a: any, b: any) => {
        return a.ratePlan?.price?.value - b.ratePlan?.price?.value;
      });
    }

    return property;
  }

  async onProductSearch() {
    // this.isSearched = true;
    this.loading = true;

    compass
      .do('prices', 'find', {
        query: {
          market: this.queryForm.fields.market,
          adults: this.queryForm.fields.adults,
          children: this.queryForm.fields.children,
          search: this.queryForm.fields.search,
          checkInDate: this.$formatDate(this.queryForm.fields.checkInDate, 'YYYY-MM-DD'),
          checkOutDate: this.$formatDate(this.queryForm.fields.checkOutDate, 'YYYY-MM-DD'),
        },
        populate: ['category', 'address.country', 'address.province', 'address.district', 'images'],
      })
      .then((res) => {
        this.lastQuery = JSON.parse(JSON.stringify(this.queryForm.fields));
        this.searchResult = res.data;

        if (this.searchResult.length < this.currentProductIndex) {
          this.currentProductIndex = 0;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async addRoom(room: any) {
    const { data: countries } = await compass.do('geo', 'countries', {
      filter: { countryCode: this.lastQuery.market },
    });

    const [market] = countries;

    room.adults = Array.from({ length: room.adults }, () => {
      return {
        gender: 'MALE',
        name: '',
        surname: '',
        identityDocument: {
          citizenship: market.id,
          type: market.id === room.propertyCountry ? 'ID' : 'PASSPORT',
        },
      };
    });

    room.children = Array.from({ length: room.children.length }, (child, childIndex) => {
      return {
        gender: 'MALE',
        name: '',
        surname: '',
        identityDocument: {
          citizenship: market.id,
          type: market.id === room.propertyCountry ? 'ID' : 'PASSPORT',
        },
        dateOfBirth: moment().subtract(room.children[childIndex], 'years').toDate(),
      };
    });

    this.form.fields.products?.push(room);

    const request = compass.do('prices', 'findByPropertyId', {
      params: {
        propertyId: room.property,
      },
      query: {
        checkInDate: room.checkInDate,
        checkOutDate: room.checkOutDate,
        market: room.market,
        adults: room.adults.length,
        children: room.children.map(() => 0),
      },
    });

    request.then((res) => res.data).then((opt) => this.setOptions(opt, room));
  }

  // CHANGES

  form: CrsForm<'orders', 'update'> = this.$crsForm('orders', 'update', {
    products: [],
  });

  get flights() {
    const { products = [] } = this.form.fields;
    return products.filter((product) => product.productCategory === 'FLIGHT') as IProductFlight[];
  }

  get rooms() {
    const { products = [] } = this.form.fields;
    return products.filter((product) => product.productCategory === 'PROPERTY') as IProductProperty[];
  }

  get areAllFlightsLocal() {
    const checkRoutes = (route: any) => {
      return (
        (route.arrival.country as IPlace).countryCode === 'TR' &&
        (route.departure.country as IPlace).countryCode === 'TR'
      );
    };

    return this.flights.every((product) => {
      let isLocal = false;
      if (product.outboundFlight) isLocal = product.outboundFlight.routes.every(checkRoutes);
      if (isLocal && product.returnFlight) isLocal = product.returnFlight.routes.every(checkRoutes);
      return isLocal;
    });
  }

  propertyCountry = 0;

  isLocalPassenger(passenger: IProductProperty['adults'][number]) {
    let isLocalPassenger = true;
    if (this.flights.length) {
      isLocalPassenger = this.areAllFlightsLocal;
    }

    if (isLocalPassenger) {
      isLocalPassenger = this.propertyCountry === passenger.identityDocument?.citizenship;
    }

    return isLocalPassenger;
  }

  get propertyTypes() {
    return PROPERTY_TYPES;
  }

  productOptions: any = {};

  addGuest(product: any, guestType: 'adult' | 'child') {
    const { identityDocument } = product.adults[0] || { identityDocument: { type: 'passport', citizenship: 0 } };

    const guest = {
      name: '',
      surname: '',
      gender: 'MALE',
      dateOfBirth: guestType === 'child' ? Date.now() : null,
      identityDocument: {
        citizenship: identityDocument.citizenship,
        type: identityDocument.type,
      },
    };

    if (guestType === 'adult') {
      product.adults.push(guest);
    } else {
      product.children.push(guest);
    }
  }

  onMarketChange() {
    this.setProductOptions();
  }

  getRatePlanOptions(product: any) {
    const result =
      this.productOptions?.[product.id]?.rooms?.find((option: any) => option.value === product.room)?.ratePlans || [];

    return result;
  }

  setOptions(options: any, product: any) {
    const roomOptions = options.map((room: any) => {
      return {
        label: room.displayName,
        value: room.id,
        ratePlans: room.ratePlans.map((ratePlan: any) => {
          return {
            label: ratePlan.type?.name,
            value: ratePlan.id,
          };
        }),
      };
    });

    const currentRoomOptionIndex = roomOptions.findIndex((option: any) => option.value === product.room);

    if (currentRoomOptionIndex <= -1) {
      roomOptions.unshift({
        label: product.roomName,
        value: product.room,
        ratePlans: [
          {
            label: product.ratePlanName,
            value: product.ratePlan,
          },
        ],
      });
    } else if (
      roomOptions[currentRoomOptionIndex].ratePlans.findIndex(
        (ratePlanOption: any) => ratePlanOption.value === product.ratePlan,
      ) <= -1
    ) {
      roomOptions[currentRoomOptionIndex].ratePlans.unshift({
        label: product.ratePlanName,
        value: product.ratePlan,
      });
    }

    this.$set(this.productOptions, product.id, {
      rooms: roomOptions,
    });
  }

  setProductOptions() {
    const requests: any[] = [];
    const products: any = this.form.fields.products || [];
    const propertyProducts: IProductProperty[] = products.filter(
      (product: any) => product.productCategory === 'PROPERTY',
    );

    propertyProducts?.forEach((product: any) => {
      const request = compass.do('prices', 'findByPropertyId', {
        params: {
          propertyId: product.property,
        },
        query: {
          checkInDate: product.checkInDate,
          checkOutDate: product.checkOutDate,
          market: product.market,
          adults: product.adults.length,
          children: product.children.map(() => 0),
        },
      });

      requests.push(request.then((res) => res.data).then((res) => this.setOptions(res, product)));
    });

    return Promise.all(requests);
  }

  async getForm() {
    const { data: order } = await compass.do('orders', 'findOne', {
      params: { orderId: this.id },
      populate: [
        { path: 'products.property', select: ['name', 'address.country'] },
        { path: 'products.room' },
        {
          path: 'products.ratePlan',
          populate: [
            { path: 'type', select: ['name'] },
            { path: 'concept', select: ['name'] },
            { path: 'cancellationPolicy', select: ['name'] },
          ],
        },
      ],
    });

    // this.order = order as any;
    const { products = [] } = order as any;

    order.products = products.map((product: any) => {
      if (product.productCategory === 'PROPERTY') {
        product.propertyName = product.property?.name;
        product.roomName = product.room?.displayName;
        product.ratePlanName = product.ratePlan?.type?.name;
        product.cancellationPolicy = product.cancellationPolicy?.id || product.cancellationPolicy;
        product.concept = product.concept?.id || product.concept;
        product.ratePlan = product.ratePlan?.id;
        product.contactId = product.room?.contract;

        this.propertyCountry = product.property?.address?.country;

        this.queryForm.fields.checkInDate = product.checkInDate;
        this.queryForm.fields.checkOutDate = product.checkOutDate;
        this.queryForm.fields.market = product.market;
        this.queryForm.fields.search = product.propertyName;
      }
      return product;
    });

    this.form.setFields(order as any);
    this.setProductOptions();
    return order as any;
  }

  preSubmit() {
    this.form.fields.type = 'CHANGE';
  }
}
